/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Restore_YesInputs */



/**
* | output |
* | --- |
* | "Yes, restore round" |
*
* @param {Rounds_Restore_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_restore_yes = /** @type {((inputs?: Rounds_Restore_YesInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Restore_YesInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, restaurer la ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, restaurar ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sim, restaurar rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, ripristina round")
	return /** @type {LocalizedString} */ ("Yes, restore round")
});